import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import styles from '../biancaelucas/biancaelucas.module.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Imagens do carrossel
import IMAGE1 from './src/IMAGE1.png';
import IMAGE2 from './src/IMAGE2.png';
import IMAGE3 from './src/IMAGE3.png';
import IMAGE4 from './src/IMAGE4.png';
import IMAGE5 from './src/IMAGE5.png';
// Imagem de fundo do carrossel
import BACKGROUND_IMAGE from './src/background-carrossel.png';

const Biancaelucas: React.FC = () => {
    const [timeLeft, setTimeLeft] = useState({
        anos: 0,
        meses: 0,
        dias: 0,
        horas: 0,
        minutos: 0,
        segundos: 0,
    });

    const targetDate = new Date('2021-08-28T00:00:00');

    const calculateTimeDifference = () => {
        const now = new Date();
        let anos = now.getFullYear() - targetDate.getFullYear();
        let meses = now.getMonth() - targetDate.getMonth();
        let dias = now.getDate() - targetDate.getDate();
        let horas = now.getHours() - targetDate.getHours();
        let minutos = now.getMinutes() - targetDate.getMinutes();
        let segundos = now.getSeconds() - targetDate.getSeconds();

        if (segundos < 0) {
            segundos += 60;
            minutos--;
        }
        if (minutos < 0) {
            minutos += 60;
            horas--;
        }
        if (horas < 0) {
            horas += 24;
            dias--;
        }
        if (dias < 0) {
            const daysInPreviousMonth = new Date(now.getFullYear(), now.getMonth(), 0).getDate();
            dias += daysInPreviousMonth;
            meses--;
        }
        if (meses < 0) {
            meses += 12;
            anos--;
        }

        setTimeLeft({ anos, meses, dias, horas, minutos, segundos });
    };

    useEffect(() => {
        const interval = setInterval(calculateTimeDifference, 1000);
        return () => clearInterval(interval);
    }, []);

    const settings = {
        dots: false,
        infinite: true,
        arrows: false,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const images = [
        { src: IMAGE1 },
        { src: IMAGE2 },
        { src: IMAGE3 },
        { src: IMAGE4 },
        { src: IMAGE5 },
    ];

    return (
        <div className={styles.biancaelucas}>
            {/* Carrossel */}
            <div
                style={{
                    backgroundImage: `url(${BACKGROUND_IMAGE})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100vh',
                }}
            >
                <Slider {...settings}>
                    {images.map((image, index) => (
                        <div key={index}>
                            <img
                                src={image.src}
                                alt={`Imagem ${index + 1}`}
                                className="pe-4 ps-4"
                                style={{
                                    width: '100%',
                                    borderRadius: '10px',
                                }}
                            />
                        </div>
                    ))}
                </Slider>
                <div style={{ marginTop: "-40px" }} className="d-flex justify-content-center flex-column align-items-center">
                    <h1 className={styles["title-carousel"]}>
                        Bianca & Lucas
                    </h1>
                    <p className={styles["subtitle-carousel"]}>
                        28/08/2021
                    </p>
                </div>
            </div>

            {/* Seção 1 */}
            <div className={styles["counter-section"]}>
                <div className="d-flex flex-column align-items-center w-100">
                    {/* Título que descreve o tempo juntos */}
                    <h2 className={styles["counter-title"]}>Contando Momentos</h2>
                    <h2 className={styles["counter-subtitle"]}>Ao Seu Lado</h2>

                    <div className="d-flex flex-wrap justify-content-around w-100">
                        {['anos', 'meses', 'dias', 'horas', 'minutos', 'segundos'].map((unit, index) => (
                            <div
                                key={index}
                                className={styles["counter-box"]}
                            >
                                <div>
                                    <h3 className="mb-0">{timeLeft[unit as keyof typeof timeLeft]}</h3>
                                    <p className="mb-0">{unit.charAt(0).toUpperCase() + unit.slice(1)}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Outras seções */}
            <div
                style={{
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#e0e0e0',
                    padding: '20px',
                }}
            >
                <h1>Seção 2</h1>
            </div>

            <div
                style={{
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#c8c8c8',
                    padding: '20px',
                }}
            >
                <h1>Seção 3</h1>
            </div>

            <div
                style={{
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#b0b0b0',
                    padding: '20px',
                }}
            >
                <h1>Seção 4</h1>
            </div>
        </div>
    );
};

export default Biancaelucas;
